import { useQuery } from '@tanstack/react-query';
import { Users, ShoppingBag, Wallet, AlertTriangle } from 'lucide-react';
import { adminApi } from '@/api';
import { Card, CardContent } from '@/components/ui/card';
import { formatRub } from '@/lib/utils';

type Stats = {
  usersTotal: number;
  usersNewLast30d: number;
  ordersTotal: number;
  revenueMinor: number;
  pendingDeliveries: number;
};

export function AdminDashboard() {
  const { data, isLoading } = useQuery<Stats>({
    queryKey: ['admin', 'stats'],
    queryFn: adminApi.stats,
  });

  if (isLoading) return <p className="text-eol-desc">Загрузка…</p>;
  if (!data) return null;

  const tiles = [
    { label: 'Пользователей', value: data.usersTotal, icon: Users, hint: `+${data.usersNewLast30d} за 30 дней` },
    { label: 'Заказов', value: data.ordersTotal, icon: ShoppingBag, hint: 'за всё время' },
    {
      label: 'Доход',
      value: formatRub(data.revenueMinor),
      icon: Wallet,
      hint: 'оплачено',
    },
    {
      label: 'В очереди плагина',
      value: data.pendingDeliveries,
      icon: AlertTriangle,
      hint: data.pendingDeliveries > 0 ? 'требуют выдачи через плагин' : 'всё доставлено',
    },
  ];

  return (
    <div>
      <h1 className="text-3xl font-extrabold text-eol-white">Дашборд</h1>
      <div className="mt-6 grid sm:grid-cols-2 lg:grid-cols-4 gap-4">
        {tiles.map((t) => (
          <Card key={t.label}>
            <CardContent className="pt-6">
              <t.icon className="h-5 w-5 text-eol-pink" />
              <p className="mt-2 text-3xl font-extrabold text-eol-white">{t.value}</p>
              <p className="text-sm text-eol-desc">{t.label}</p>
              <p className="text-xs text-eol-desc/70 mt-2">{t.hint}</p>
            </CardContent>
          </Card>
        ))}
      </div>
    </div>
  );
}
